import { SelectField, SubmitHandler } from '@ff-it/form';
import type { RenderProps } from '@ff-it/ui';
import { BlockWidget, DialogForm, useOptions } from 'components';
import type { BlockDetails } from 'modules/campaign/block/types';
import type { ReactElement } from 'react';
import type { ActivityType } from 'types';

type CodeImportProps = {
  type: ActivityType;
  blockId: number;
};

function ImportableBlockField({ blockId, type }: CodeImportProps): ReactElement {
  const loadOptions = useOptions<BlockDetails>('campaign/blocks/', { type, exclude: blockId });

  return (
    <SelectField<any>
      autoFocus
      loadOptions={loadOptions}
      getOptionLabel={({ code, title }) => `${title} ${code}`}
      formatOptionLabel={BlockWidget}
      name="block"
      placeholder="Import code..."
      required
    />
  );
}

export function ImportBlockDialog({
  blockId,
  type,
  ...props
}: CodeImportProps & {
  submitHandler: SubmitHandler<{ block: BlockDetails }>;
} & RenderProps<undefined>) {
  return (
    <DialogForm {...props} title="Import block" initialValues={{ block: null }}>
      <ImportableBlockField blockId={blockId} type={type} />
    </DialogForm>
  );
}
